import type { ComponentType } from 'react';

import Tile4Wrapper from './Links';
import StandardTiles from './StandardTiles/StandardTiles';
import type { Tile4variants, Tiles4Props } from './types';

const components = {
    Standard: StandardTiles,
    Links: Tile4Wrapper,
} as Record<Tile4variants, ComponentType<Tiles4Props>>;

export default function Tiles4(props: Tiles4Props) {
    const Component = components[props.variant] ?? 'div';

    return <Component {...props} />;
}
